"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*

The actual code for the my page component is found in rubics-service

*/
var Booking = {
    name: "global:booking",
    label: "Booking",
    description: "Med Booking-komponenten kan kundene dine booke arrangementer og avtaler som ikke er tilknyttet produkter.",
    reactComponent: function () { return null; },
    icon: "booking",
    usableInSection: true,
    usableInRichContent: true,
    props: [
        {
            name: "bookingService",
            label: "Tjeneste",
            type: "ref",
            to: "bookingService",
            required: true,
        },
        {
            name: "text",
            label: "Tekst",
            type: "draft",
        },
        {
            name: "hideLogin",
            label: "Skjul logg inn-knapp",
            type: "boolean",
        },
    ],
};
exports.default = Booking;
//# sourceMappingURL=index.js.map